module.exports = __webpack_public_path__ + "img/orca.b5ab2746.svg";